module.exports = __webpack_public_path__ + "asset/zhengpian_2C4EVz4c.png";